import { render, staticRenderFns } from "./ApplyGroupInfo.vue?vue&type=template&id=aa0d667a&scoped=true"
import script from "./ApplyGroupInfo.vue?vue&type=script&lang=js"
export * from "./ApplyGroupInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0d667a",
  null
  
)

export default component.exports